import { PositionType, TickType } from "../http/types";
import { TimeFrameType } from "../resources/types";

export type PageTimeFrameType = TimeFrameType & { zoomIn?: boolean };

export type LogSeverity =
  | "DEBUG"
  | "INFO"
  | "WARNING"
  | "ERROR"
  | "NOTICE"
  | "FATAL";

export const severityLevels: LogSeverity[] = [
  "DEBUG",
  "INFO",
  "WARNING",
  "ERROR",
  "NOTICE",
  "FATAL"
];

export interface StackedLogDataPoint extends d3.SeriesPoint<LogOverviewPoint> {
  data: LogOverviewPoint;
  key: LogSeverity;
}

export interface StackedLogSeries extends Array<StackedLogDataPoint> {
  key: LogSeverity;
  index: number;
}

export type LogOverviewPoint = {
  timestamp: number;
  timestampDate: Date;

  DEBUG: number;
  NOTICE: number;
  INFO: number;
  WARNING: number;
  ERROR: number;
  FATAL: number;

  total: number;
};

export type LayoutType = {
  positions: PositionType;
  xScale: d3.ScaleBand<Date>;
  yScale: d3.ScaleLinear<any, any>;
  children?: React.ReactNode;
  chartId: string;
  tick?: TickType;
};

export type BarProps<D> = {
  fill: string;
  data: D;
  xScale: d3.ScaleBand<Date>;
  yScale: d3.ScaleLinear<any, any>;
  chartId?: string;
  onMouseOver?: (event: any, point: LogOverviewPoint) => void;
  onMouseLeave?: () => void;
};
